import { render, staticRenderFns } from "./ButtonInspect.vue?vue&type=template&id=1efdd406&"
import script from "./ButtonInspect.vue?vue&type=script&lang=ts&"
export * from "./ButtonInspect.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonInspect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports